jQuery(document).ready(function ($) {
	const $team_block = $(".footer-tiles");
	const $team_slider = $(".footer-slider");

	function initTeamSlider() {
		if ($team_slider.hasClass("slick-initialized")) return;
		if (typeof $.fn.slick === "undefined") {
			console.warn("Slick slider not loaded yet for team-slider");
			return;
		}

		$team_slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			appendDots: $team_block.find(".slide-m-dots"), // ✅ fixed selector
			adaptiveHeight: true,
			speed: 900,
			fade: true,
			cssEase: "cubic-bezier(0.77, 0, 0.175, 1)",
		});
	}

	function destroyTeamSlider() {
		if ($team_slider.hasClass("slick-initialized")) {
			$team_slider.slick("unslick");
		}
	}

	function checkMobile() {
		if (window.innerWidth <= 768) {
			initTeamSlider();
		} else {
			destroyTeamSlider();
		}
	}

	checkMobile();
	$(window).on("resize", checkMobile);
});
